import { render, staticRenderFns } from "./NavSecondary.vue?vue&type=template&id=508fce2c&"
import script from "./NavSecondary.vue?vue&type=script&lang=js&"
export * from "./NavSecondary.vue?vue&type=script&lang=js&"
import style0 from "./NavSecondary.vue?vue&type=style&index=0&id=508fce2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports